import React from 'react';

const IconPlus = (props) => {

  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7 9V16H9V9H16V7H9V0H7V7H0V9H7Z" fill="#94D2B9"/>
    </svg>
  );
}

export default IconPlus;